import React from 'react';

// Styling
import { homeCss } from '@digital_monorepo/styling';

const HoursDisplay = ({ hours, freetime }) => {
  const getColor = value => {
    if (value <= 20) {
      return homeCss.darkGreen;
    } else if (value <= 30) {
      return homeCss.orange;
    } else if (value <= 40) {
      return homeCss.darkRed;
    } else {
      console.warn('Value out of range');
      return null;
    }
  };

  return (
    <span className={homeCss.hours}>
      <span className={getColor(hours)}> {hours}</span>
    </span>
  );
};

export default HoursDisplay;
